import React from 'react';
import { tiItemKind } from '../../triage/utils';
import type { TriageItem, TriageStatus } from '../../triage/types';
import { EmptyState } from '../EmptyState/EmptyState';
import { TriageAttentionDetail } from './TriageAttentionDetail';
import { TriageCallTaskDetail } from './TriageCallTaskDetail';

export interface TriageDetailPanelProps {
  item: TriageItem | null;
  noteText: string;
  setNoteText: (value: string) => void;
  onChangeStatus: (id: number, status: TriageStatus) => void;
  onChangeAssignee: (id: number, assigneeId: string | null) => void;
  onAddNote: (id: number) => void;
  onExecuteAction?: (itemId: number, actionId: string, editedBody?: string) => void;
  onOpenSource?: (item: TriageItem) => void;
  /** Overrides the default empty box shown when no item is selected. */
  emptyState?: React.ReactNode;
}

export function TriageDetailPanel({
  item,
  noteText,
  setNoteText,
  onChangeStatus,
  onChangeAssignee,
  onAddNote,
  onExecuteAction,
  onOpenSource,
  emptyState,
}: TriageDetailPanelProps) {
  if (!item) {
    return (
      <div className="flex min-h-0 flex-1 p-8">
        {emptyState ?? (
          <EmptyState
            fill
            className="w-full"
            icon="sparkle"
            title="Select an item to review"
            sub="Elva-flagged messages, calls, and survey responses live here."
          />
        )}
      </div>
    );
  }

  const kind = tiItemKind(item);

  if (kind === 'call_task') {
    return (
      <TriageCallTaskDetail
        item={item}
        noteText={noteText}
        setNoteText={setNoteText}
        onChangeStatus={onChangeStatus}
        onChangeAssignee={onChangeAssignee}
        onAddNote={onAddNote}
        {...(onOpenSource ? { onOpenSource } : {})}
      />
    );
  }

  return (
    <TriageAttentionDetail
      item={item}
      noteText={noteText}
      setNoteText={setNoteText}
      onChangeStatus={onChangeStatus}
      onChangeAssignee={onChangeAssignee}
      onAddNote={onAddNote}
      {...(onExecuteAction ? { onExecuteAction } : {})}
      {...(onOpenSource ? { onOpenSource } : {})}
    />
  );
}
